// src/app/pages/VehicleMovementReport/ExportToExcelButton.tsx
import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import toast from 'react-hot-toast'
import ExcelJS from 'exceljs'

import { validateFleetDataForExport } from './validateData'
import { generateLoginstatusWorksheet } from './worksheetGenerator'
import { saveWorkbookAsExcel } from '../../../helpers/saveWorkbook'
import { autoSizeColumns } from '../../../helpers/autoSizeColumns'

interface ExportToExcelProps {
  data: Array<Record<string, any>>
  fileName?: string
  titleMap: Record<string, string>
  heading?: string
  imgPath?: string // full URL of logo, e.g., API_URL/uploads/logo/mes_logo.jpg
}

const ExportToExcelButton: React.FC<ExportToExcelProps> = ({
  data,
  fileName = 'ExportedData',
  titleMap,
  heading,
  imgPath,
}) => {
  const [isExporting, setIsExporting] = useState(false)

  const handleExport = async () => {
    if (!validateFleetDataForExport(data)) {
      toast.error('No data to export!')
      return
    }

    try {
      setIsExporting(true)

      const workbook = new ExcelJS.Workbook()
      workbook.creator = 'TrackNAB'
      workbook.created = new Date()

      // Generate worksheet with logo and data
      const worksheet = await generateLoginstatusWorksheet(
        workbook,
        data,
        titleMap,
        imgPath
      )

      // Auto size all columns
      autoSizeColumns(worksheet)

      // Save file and trigger download
      await saveWorkbookAsExcel(workbook, fileName)

      toast.success('Export completed.')
    } catch (err) {
      console.error('Export error:', err)
      toast.error('Failed to export data.')
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <Button onClick={handleExport} disabled={isExporting} size="sm">
      <div className="d-flex align-items-center gap-2">
        Download
        {isExporting ? (
          <i className="bi bi-arrow-repeat spinner-border spinner-border-sm ms-2" />
        ) : (
          <i className="bi bi-download fs-5 ms-2" />
        )}
      </div>
    </Button>
  )
}

export default ExportToExcelButton
